import React from 'react';
import { Card, CardHeader } from '../../ui/card';
import { Button } from '../../ui/button';
import { MessageSquare } from 'lucide-react';

const SupportRequestsTab = ({
 supportRequests,
 onUpdateRequest
}) => {
 return (
 <div className="space-y-4">
 {supportRequests.length === 0 ? (
 <Card className="p-8 text-center">
 <MessageSquare className="w-16 h-16 mx-auto mb-4 text-slate-400" />
 <p className="text-slate-600 dark:text-neutral-400">No support requests</p>
 </Card>
 ) : (
 supportRequests.map((request) => (
 <Card key={request.id}>
 <CardHeader>
 <div className="flex items-start justify-between">
 <div className="flex-1">
 <div className="flex items-center gap-3 mb-2">
 <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
 request.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
 request.status === 'in_progress' ? 'bg-blue-100 text-blue-800' :
 'bg-green-100 text-green-800'
 }`}>
 {request.status.toUpperCase()}
 </span>
 <span className="text-sm text-slate-500 dark:text-neutral-500">
 {new Date(request.created_at).toLocaleDateString()}
 </span>
 </div>
 <p className="text-slate-900 dark:text-white mb-2">{request.message}</p>
 {request.admin_response && (
 <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg mt-3">
 <p className="text-sm font-semibold text-blue-900 dark:text-blue-100 mb-1">Admin Response:</p>
 <p className="text-sm text-blue-800 dark:text-blue-200">{request.admin_response}</p>
 </div>
 )}
 </div>
 <div className="flex gap-2">
 <Button
 size="sm"
 onClick={() => {
 const response = prompt('Enter your response:');
 if (response) {
 onUpdateRequest(request.id, 'resolved', response);
 }
 }}
 className="bg-green-600 hover:bg-green-700"
 >
 Respond
 </Button>
 {request.status !== 'resolved' && (
 <Button
 size="sm"
 variant="outline"
 onClick={() => onUpdateRequest(request.id, 'resolved', request.admin_response)}
 >
 Mark Resolved
 </Button>
 )}
 </div>
 </div>
 </CardHeader>
 </Card>
 ))
 )}
 </div>
 );
};

export default SupportRequestsTab;
